import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export const getAdminUserById = async (user_id: number): Promise<UserProfile> => {
  const { data } = await client.get(`/admin/users/${user_id}`);

  return data;
};
